import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { TooltipProvider } from '@/ui/tooltip'
import { App } from './app'
import { devLogin, setupAuth } from '@/lib/auth'
import { queryClient } from '@/lib/query-client'
import { identityApi } from '@/modules/identity'
import { BrandProvider } from '@/shared/providers/brand-provider'
import { ThemeProvider } from '@/shared/providers/theme-provider'
import { AppErrorBoundary } from './error-boundary'
import '@/shared/styles/globals.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found in index.html')
}

const root = createRoot(rootElement)

root.render(
  <StrictMode>
    <main className="bg-background flex min-h-screen items-center justify-center p-6">
      <p className="text-muted-foreground text-sm">Loading…</p>
    </main>
  </StrictMode>,
)

if (import.meta.env.DEV) {
  ;(window as unknown as { __devLogin: typeof devLogin }).__devLogin = devLogin
}

void setupAuth(identityApi.me)
  .catch((e) => {
    console.error('[main] auth setup failed', e)
  })
  .finally(() => {
    root.render(
      <StrictMode>
        <AppErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <BrandProvider>
              <ThemeProvider>
                <TooltipProvider>
                  <App />
                </TooltipProvider>
              </ThemeProvider>
            </BrandProvider>
          </QueryClientProvider>
        </AppErrorBoundary>
      </StrictMode>,
    )
  })
